import React from 'react';
import { MdOutlineInventory } from 'react-icons/md';
import SidebarFlyoutNavRow from './SidebarFlyoutNavRow';
import { ADMIN_FLYOUT_IDS } from './SidebarFlyoutContext';
import {
  buildInventoryFlyoutItems,
  hasInventorySidebarAccess,
} from './inventory/inventoryNavConfig';

function InventoryFlyoutRow({ SubMenuItem, hasMenuAccess, closeMobileSidebar, indentClass = 'ps-5' }) {
  const items = buildInventoryFlyoutItems(hasMenuAccess);
  if (items.length === 0) return null;

  return (
    <SidebarFlyoutNavRow
      flyoutId={ADMIN_FLYOUT_IDS.inventory}
      label="Inventory"
      flyoutTitle="Inventory"
      items={items}
      SubMenuItem={SubMenuItem}
      closeMobileSidebar={closeMobileSidebar}
      indentClass={indentClass}
      flyoutWidth={360}
      alwaysFlyout
    />
  );
}

function FieldInventoryBlock({ MenuItem, SubMenuItem, hasMenuAccess }) {
  return (
    <MenuItem customIcon={<MdOutlineInventory style={{ width: '24px', height: '24px' }} />} title="Field inventory" id="inventory-field">
      {(hasMenuAccess('/inventory/mobile') || hasMenuAccess('/inventory')) && (
        <SubMenuItem to="/inventory/mobile">Field entry (mobile hub)</SubMenuItem>
      )}
      {(hasMenuAccess('/inventory/new') || hasMenuAccess('/inventory')) && (
        <SubMenuItem to="/inventory/mobile/new">New asset</SubMenuItem>
      )}
    </MenuItem>
  );
}

function FullInventoryBlock({ MenuItem, SubMenuItem, hasMenuAccess }) {
  return (
    <MenuItem customIcon={<MdOutlineInventory style={{ width: '24px', height: '24px' }} />} title="Inventory" id="inventory">
      {hasMenuAccess('/inventory/dashboard') && <SubMenuItem to="/inventory">Inventory Dashboard</SubMenuItem>}
      {hasMenuAccess('/inventory/new') && <SubMenuItem to="/inventory/new">New Asset</SubMenuItem>}
      <div className="border-top border-secondary my-1 mx-4"></div>
      {hasMenuAccess('/inventory/kits') && <SubMenuItem to="/inventory/kits">Equipment Kits</SubMenuItem>}
      {(hasMenuAccess('/inventory/mobile') || hasMenuAccess('/inventory')) && (
        <SubMenuItem to="/inventory/mobile">Field entry (mobile hub)</SubMenuItem>
      )}
      <div className="border-top border-secondary my-1 mx-4"></div>
      {hasMenuAccess('/inventory/parameters') && <SubMenuItem to="/inventory/parameters">Parameters</SubMenuItem>}
      {hasMenuAccess('/inventory/vendors') && <SubMenuItem to="/inventory/vendors">Vendors / Suppliers</SubMenuItem>}
    </MenuItem>
  );
}

/**
 * Inventory sidebar block (desktop NavigationBar).
 * Under Administration: single flyout row (Drilling → Budget pattern).
 */
function InventoryNavSection({
  MenuItem,
  SubMenuItem,
  hasMenuAccess,
  hasMenuAccessOrChild,
  closeMobileSidebar,
  nested = false,
}) {
  if (!hasInventorySidebarAccess(hasMenuAccess, hasMenuAccessOrChild)) {
    return null;
  }

  if (nested) {
    return (
      <InventoryFlyoutRow
        SubMenuItem={SubMenuItem}
        hasMenuAccess={hasMenuAccess}
        closeMobileSidebar={closeMobileSidebar}
        indentClass="ps-5"
      />
    );
  }

  const showFieldOnly =
    (hasMenuAccess('/inventory/mobile') || hasMenuAccess('/inventory/new'))
    && !hasMenuAccess('/inventory');

  return (
    <>
      {showFieldOnly && (
        <FieldInventoryBlock
          MenuItem={MenuItem}
          SubMenuItem={SubMenuItem}
          hasMenuAccess={hasMenuAccess}
        />
      )}

      {hasMenuAccessOrChild('/inventory', [
        '/inventory/dashboard',
        '/inventory/new',
        '/inventory/kits',
        '/inventory/parameters',
        '/inventory/vendors',
      ]) && (
        <FullInventoryBlock
          MenuItem={MenuItem}
          SubMenuItem={SubMenuItem}
          hasMenuAccess={hasMenuAccess}
        />
      )}
    </>
  );
}

export default InventoryNavSection;
